import axios from 'axios'

export const SCOREBOARD = 'scoreboard/SCOREBOARD'

let initialState = {
	isRequestingData: false,
	scoreboard: [],
	tempScoreboard: [
		{
			"User": "Adam Borrows",
			"Country": {
				"Id": 232,
				"Code": "GB",
				"Name": "United Kingdom"
			},
			"Skills": "Hacking",
			"Completed": 25,
			"Score": 2460
		},
		{
			"User": "Jason Colber",
			"Country": {
				"Id": 233,
				"Code": "US",
				"Name": "United States"
			},
			"Skills": "Hacking",
			"Completed": 25,
			"Score": 2390
		},
		{
			"User": "Daniel Cohen",
			"Country": {
				"Id": 107,
				"Code": "IL",
				"Name": "Israel"
			},
			"Skills": "Pentesting",
			"Completed": 25,
			"Score": 2370
		},
		{
			"User": "Donald Bary",
			"Country": {
				"Id": 216,
				"Code": "TW",
				"Name": "Taiwan"
			},
			"Skills": "Incident Response",
			"Completed": 25,
			"Score": 2260
		},
		{
			"User": "Ben Vilko",
			"Country": {
				"Id": 107,
				"Code": "CA",
				"Name": "Canada"
			},
			"Skills": "Pentesting",
			"Completed": 25,
			"Score": 2150
		},
		{
			"User": "Buren Von Graph",
			"Country": {
				"Id": 107,
				"Code": "NL",
				"Name": "Netherlands"
			},
			"Skills": "Forensic Investigations",
			"Completed": 25,
			"Score": 1980
		},
		{
			"User": "Fridrich Daniel",
			"Country": {
				"Id": 107,
				"Code": "DE",
				"Name": "Germany"
			},
			"Skills": "Incident Response",
			"Completed": 25,
			"Score": 1950
		},
	]
}

export default (state = initialState, action) => {
	switch (action.type) {
		case SCOREBOARD:
			return {
				...state,
				scoreboard: action.payload,
				isRequestingData: false
			}
		default:
			return state
	}
}

export const getScoreboard = () => {
	return (dispatch, getState) => {
		axios.get('https://incident-response-challenge.com/middleware/scoreboard')
		.then((response) => {
			dispatch({
				type: SCOREBOARD,
				payload: response.data
			})
		})
	}
}